/* WL Store: the few things the theme adds on top of Dawn.
   Delegated listeners, because Dawn re-renders the product info on every
   variant change and would drop listeners bound to the old nodes. */
(() => {
  // size chart dialogs: a button with data-wl-dialog="<id>" opens <dialog id>
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-wl-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.wlDialog);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
        dialog.querySelector('[data-wl-close]')?.focus();
      }
      return;
    }
    if (event.target.closest('[data-wl-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }
    // a click on the backdrop lands on the dialog element itself
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('wl-dialog')) {
      const r = event.target.getBoundingClientRect();
      const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) event.target.close();
    }
  });

  // inches and centimeters on the size tables
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wl-units]');
    if (!button) return;
    const unit = button.dataset.wlUnits;
    const scope = button.closest('[data-wl-size-scope]') || document;
    scope.querySelectorAll('[data-wl-units]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wlUnits === unit)));
    scope.querySelectorAll('[data-in]').forEach((cell) => {
      cell.textContent = unit === 'cm' ? cell.dataset.cm : cell.dataset.in;
    });
  });

  // "ships between" dates on the product page, counting business days from today
  const addBusinessDays = (from, days) => {
    const d = new Date(from);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return d;
  };
  const fillShipDates = () => {
    document.querySelectorAll('[data-wl-ship]').forEach((box) => {
      const out = box.querySelector('[data-wl-ship-date]');
      if (!out || out.textContent.trim()) return;
      const min = parseInt(box.dataset.min, 10);
      const max = parseInt(box.dataset.max, 10);
      if (!min || !max) return;
      const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      const now = new Date();
      const a = fmt.format(addBusinessDays(now, Math.min(min, max)));
      const b = fmt.format(addBusinessDays(now, Math.max(min, max)));
      out.textContent = a === b ? `Usually ships by ${b}.` : `Usually ships between ${a} and ${b}.`;
    });
  };
  fillShipDates();
  document.querySelectorAll('product-info').forEach((el) => {
    new MutationObserver(fillShipDates).observe(el, { childList: true, subtree: true });
  });

  // headline lines rise in once, when they come into view
  const reveals = document.querySelectorAll('.wl-reveal');
  if (!reveals.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveals.forEach((el) => el.classList.add('in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  reveals.forEach((el) => io.observe(el));
})();
